/* import __COLOCATED_TEMPLATE__ from './withholding.hbs'; */
var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import { action, computed, set } from '@ember/object';
import { Action, getEvent, Page, Target } from '@banking/ui/utils/folder-cdp-events';
let Withholding = (_dec = computed('automationSubaccountState.{applyBpsToAllLocations,isWithholdingConfigValid,unitWithholdingConfigs}'), _class = class Withholding extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _initializerDefineProperty(this, "automationSubaccountState", _descriptor, this);
    _initializerDefineProperty(this, "dataApi", _descriptor2, this);
    _defineProperty(this, "continue", void 0);
    _defineProperty(this, "goBack", void 0);
    _defineProperty(this, "create", void 0);
  }
  didInsertElement() {
    super.didInsertElement();
    const {
      name,
      properties
    } = getEvent(Action.View, {
      page: Page.ChooseContribution
    });
    this.dataApi.track(name, properties);
  }
  get canContinue() {
    return this.automationSubaccountState.isWithholdingConfigValid && (this.automationSubaccountState.applyBpsToAllLocations || this.automationSubaccountState.unitWithholdingConfigs.some(config => config.isEnabled));
  }
  _continue() {
    const {
      name,
      properties
    } = getEvent(Action.Click, {
      page: Page.ChooseContribution,
      target: Target.SetContribution
    });
    this.dataApi.track(name, properties);
    this.continue();
  }
  skip() {
    set(this.automationSubaccountState, 'withholdingBps', undefined);
    const {
      name,
      properties
    } = getEvent(Action.Click, {
      page: Page.ChooseContribution,
      target: Target.Skip
    });
    this.dataApi.track(name, properties);
    this.create();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "automationSubaccountState", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "canContinue", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "canContinue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_continue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_continue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "skip", [action], Object.getOwnPropertyDescriptor(_class.prototype, "skip"), _class.prototype), _class);
export { Withholding as default };